"use client";
// Imports
import {
  Drawer as ShadDrawer,
  DrawerContent,
} from "@/components/ui/drawer";
import Image from "next/image";
import { useEffect } from "react";
import useStore from "@/lib/state";
import { useSearchParams } from "next/navigation";
import { LogoutLink } from "@kinde-oss/kinde-auth-nextjs/components";

// Drawer
export function Drawer({
  user,
  isMobile,
  direction = "bottom",
  buttonTitle = "Open",
  title = "",
  description = "",
  totalAmount,
  children,
  isQuickLink,
}) {
  // State
  const { isMyShowOpen, setIsMyShowOpen } = useStore();
  const searchParams = useSearchParams();

  useEffect(() => {
    const isMyShowOpen = searchParams.get("myShow");

    if (isMyShowOpen) {
      setIsMyShowOpen(true);
    } else {
      setIsMyShowOpen(false);
    }
  }, []);

  // Render
  return (
    <ShadDrawer
      open={isMyShowOpen}
      onOpenChange={setIsMyShowOpen}
      direction={direction}
      shouldScaleBackground={false}
    >
      <div
        onClick={() => setIsMyShowOpen(!isMyShowOpen)}
        className="w-full text-left cursor-pointer text-brand-nav-accent lg:hover:text-brand-nav-accent/80 normal-case"
      >
        <div className="flex items-center gap-2 py-4 w-full">
          <span>{buttonTitle}</span>
          {totalAmount > 0 ? (
            <span
              aria-label={`${totalAmount} saved items`}
              className="text-xs font-bold leading-none tabular-nums text-brand-nav-accent"
            >
              {totalAmount}
            </span>
          ) : null}
        </div>
      </div>

      <DrawerContent className="w-full p-5 h-[90svh] bg-background">
        {title && (
          <div className="flex items-center justify-between mb-5 mx-auto w-full max-w-7xl gap-4">
            <h1 className="level-1">{title}</h1>
            {user && (
              <div className="flex items-center gap-3 shrink-0">
                <div className="relative size-14">
                  <div className="flex justify-center items-center text-white rounded-full size-14 bg-brand-orange">
                    {user?.given_name.slice(0, 1) +
                      user?.family_name.slice(0, 1)}
                  </div>
                  {user?.picture && (
                    <Image
                      src={user?.picture}
                      alt={user?.given_name + " " + user?.family_name}
                      width={56}
                      height={56}
                      className="absolute inset-0 rounded-full border-button-width border-button"
                    />
                  )}
                </div>
                <LogoutLink className="text-sm font-semibold text-brand-red-gum hover:text-brand-orange transition-colors">
                  Logout
                </LogoutLink>
              </div>
            )}
          </div>
        )}
        {children}
      </DrawerContent>
    </ShadDrawer>
  );
}
